import styled from 'styled-components';
import { CommandBar } from '@fluentui/react';

const StyledCommandBar = styled(CommandBar)`
    flex: 1 0 auto;
`;

export { StyledCommandBar };

